import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noValueTextExperiment: {
		id: 'issue-field-sprint-readview-full.sprint.no-value-text-experiment',
		defaultMessage: 'Add sprint',
		description: 'Message when the field has no value',
	},
});
